module.exports = __webpack_public_path__ + "img/1_013.67c7f2e0.jpg";